// @ts-nocheck

import { request } from '../../../../../context';
import type { ApiOptions } from '../../../../../context';
import type {
    PostIntelligentPartnerHomePageAdminStatisticsExportBody,
    BaseResponseVoid,
} from '../../../../../types';

/**
 * 导出总览数据
 *
 * @export
 * @tags 智能陪练首页接口
 * @link [POST] /intelligentPartner/homePage/admin/statistics/export
 */
export function postIntelligentPartnerHomePageAdminStatisticsExport(
    data: PostIntelligentPartnerHomePageAdminStatisticsExportBody
): Promise<BaseResponseVoid>;
export function postIntelligentPartnerHomePageAdminStatisticsExport(
    data: PostIntelligentPartnerHomePageAdminStatisticsExportBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseVoid>;
export function postIntelligentPartnerHomePageAdminStatisticsExport(
    data: PostIntelligentPartnerHomePageAdminStatisticsExportBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseVoid> {
    return request<PostIntelligentPartnerHomePageAdminStatisticsExportBody, never, never>(
        '/intelligentPartner/homePage/admin/statistics/export',
        {
            ...options,
            data,
            method: 'post',
            __$requestCalleeName: 'postIntelligentPartnerHomePageAdminStatisticsExport',
        }
    );
}

export const meta = [
    {
        tags: ['智能陪练首页接口'],
        path: '/intelligentPartner/homePage/admin/statistics/export',
        method: 'post',
    },
];
